const policyFields = ['encryptionPolicyVersion', 'encryptionMode', 'encryptionGeneration', 'encryptionTransition', 'lastEncryptionOperation'];

export const readEncryptionPolicy = (profile = {}) => {
  const hasPolicy = policyFields.some((field) => Object.prototype.hasOwnProperty.call(profile, field));
  if (!hasPolicy) return { kind: 'legacy', mode: null, generation: null, transition: null };

  const valid = profile.encryptionPolicyVersion === 1
    && (profile.encryptionMode === 'enabled' || profile.encryptionMode === 'disabled')
    && Number.isInteger(profile.encryptionGeneration)
    && profile.encryptionGeneration >= 0;
  if (!valid) return { kind: 'invalid', mode: null, generation: null, transition: null };

  const transition = profile.encryptionTransition;
  if (transition !== undefined && (!transition || typeof transition.operationId !== 'string' || !transition.operationId
    || (transition.sourceMode !== 'enabled' && transition.sourceMode !== 'disabled')
    || (transition.targetMode !== 'enabled' && transition.targetMode !== 'disabled')
    || transition.sourceMode !== profile.encryptionMode || transition.sourceMode === transition.targetMode
    || typeof transition.manifestDigest !== 'string' || !transition.manifestDigest
    || !Object.prototype.hasOwnProperty.call(transition, 'startedAt') || transition.startedAt == null)) {
    return { kind: 'invalid', mode: null, generation: null, transition: null };
  }
  return { kind: 'managed', mode: profile.encryptionMode, generation: profile.encryptionGeneration, transition: transition || null };
};

export const profileHasCloudKey = (profile = {}) => typeof profile.encryptedKey === 'string' && profile.encryptedKey.length > 0;

export const isPrefixCiphertext = (content, policy) => typeof content === 'string'
  && content.startsWith('encrypted:')
  && !(policy?.kind === 'managed' && policy.mode === 'disabled');
